import { createClient, Entry } from 'contentful';
import { rawToContent } from './rawToContent';
import { Content, Offer, RawOffer } from './types';

const rawToOffer = (entry: Entry<RawOffer>): Offer => ({
  ...entry.fields,
  // some values aren't able to be used verbatim
  id: entry.sys.id,
  heroImage: entry.fields.heroImage.fields.file.url,
  logo: entry.fields.logo?.fields.file.url,
  offerImage: entry.fields.offerImage?.fields.file.url,
  content: entry.fields.content.map(rawToContent).filter((e): e is Content => e !== null),
  createdAt: entry.sys.createdAt,
});

export const processOffersResponse = async (json: unknown) => {
  const client = createClient({
    // we only use the client for it's magic parsing
    space: 'unused',
    accessToken: 'unused',
  });

  const parsed = await client.parseEntries<RawOffer>(json);
  const items = parsed && parsed.items;
  const offers = items.map(rawToOffer);

  return offers;
};
